import { IActiveSkill } from "../ISkill";
import { IArrowCaster } from "../IArrowCaster";

const SPREAD_DEGREES = 8;

export default class DoubleShotSkill implements IActiveSkill {
  Name = "Double Shot";
  Description = "Fire two arrows simultaneously in a spread pattern.";
  MaxLevel = 5;
  IconKey = "skill_double_shot";
  KeyBinding = "ONE";

  ManaCost(level: number): number {
    return Math.max(10, 25 - level * 3);
  }

  CooldownMs(level: number): number {
    return Math.max(1000, 3000 - level * 400);
  }

  Execute(level: number, caster: IArrowCaster): boolean {
    const baseAngle = caster.GetAimAngle();
    caster.SpawnArrow({
      angle: baseAngle + SPREAD_DEGREES,
      damageMultiplier: 1.0,
      speedMultiplier: 1.0,
      isExploding: false,
      explosionRadius: 0,
      explosionDmgMult: 0,
    });
    caster.SpawnArrow({
      angle: baseAngle - SPREAD_DEGREES,
      damageMultiplier: 1.0,
      speedMultiplier: 1.0,
      isExploding: false,
      explosionRadius: 0,
      explosionDmgMult: 0,
    });
    return true;
  }
}
